import { render, staticRenderFns } from "./LegalDocumentFileWrapper.vue?vue&type=template&id=2ddbfad8&scoped=true&"
import script from "./LegalDocumentFileWrapper.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentFileWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddbfad8",
  null
  
)

export default component.exports